import { Link } from "react-router-dom";
import { ArrowRight, Brain, ChartBar, Cog, Layers, Rocket, Shield } from "lucide-react";
import SectionHeader from "../components/SectionHeader";
import { motion } from "framer-motion";

const SOLUTIONS = [
  { Icon: Rocket, t: "Digital Transformation", d: "Reimagine workflows with cloud-native tooling and automation." },
  { Icon: Brain, t: "AI & Data", d: "From dashboards to predictive models, turn data into decisions." },
  { Icon: ChartBar, t: "Revenue Operations", d: "Unified sales, marketing, and customer success tech stacks." },
  { Icon: Layers, t: "Product Engineering", d: "Build user-loved products with senior cross-functional pods." },
  { Icon: Shield, t: "Security & Compliance", d: "GDPR / NDPR / SOC 2 readiness baked into delivery." },
  { Icon: Cog, t: "Managed IT", d: "We run your infra so your team can run the business." },
];

export default function Solutions() {
  return (
    <section className="container-st pt-16 pb-24">
      <SectionHeader
        eyebrow="Solutions"
        title="Business-shaped technology, not the other way around."
        subtitle="Six outcome-oriented practices, each anchored by a senior partner."
      />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
        {SOLUTIONS.map(({ Icon, t, d }, i) => (
          <motion.div
            key={t}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.05 }}
            className="rounded-3xl border border-slate-100 bg-white p-8 hover:shadow-lg transition"
            data-testid={`solution-card-${i}`}
          >
            <div className="h-12 w-12 rounded-2xl bg-blue-50 grid place-items-center">
              <Icon className="w-6 h-6 text-blue-600" />
            </div>
            <h3 className="mt-5 text-xl font-semibold text-slate-900">{t}</h3>
            <p className="mt-3 text-slate-600">{d}</p>
            <Link to="/contact" className="mt-5 inline-flex items-center gap-1 text-blue-700 font-semibold text-sm">
              Discuss <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
